module.exports = __webpack_public_path__ + "static/media/pencil.96572358.png";